import { render } from "./PinIcon.vue?vue&type=template&id=472b6bb5"
import script from "./PinIcon.vue?vue&type=script&lang=js"
export * from "./PinIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__